import type { StructuralDecorator } from "../decorator.js";
import type { PreferableControl } from "../plainForm.js";
import type { ItemKeyOf, ModulesOf, TypedBy } from "../typedBy.js";

/**
 * A control for one item, in place of its plain one; the form is refused
 * where the control could collect a value the plain one could not.
 */
export const controlOf = <Typing extends TypedBy>(
  _typedBy: Typing,
  item: ItemKeyOf<ModulesOf<Typing>>,
  control: PreferableControl,
): StructuralDecorator => ({
  kind: "structural",
  item: (view) =>
    view.at.item === item ? { ...view, control: { kind: control } } : view,
});
